export default __webpack_public_path__ + "static/media/blueArrow.b66c509b.svg";